<div *ngIf="uiService.abortButtonState.visible" class="abort-button footer-button">
  <a id="back" type="button" class="btn btn-danger button-base back-button" [class.disabled]="!uiService.abortButtonState.enabled"
    (click)="onClick()">{{ uiService.abortButtonState.text | translate }}</a>
</div>
